// extracted by mini-css-extract-plugin
export var item = "TitleAnimation-module--item--1Jxg6";
export var scroll = "TitleAnimation-module--scroll--1ZJLm";
export var scrollShow = "TitleAnimation-module--scrollShow--2m7py";